import { useFieldArray, useFormContext } from "react-hook-form";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { useEditSegmentView } from "../EditSegment.context";

export function useConditionsPanel() {
  const { mdUp } = useBreakpoints();

  const { editDisabled, editDisabledTooltip, isSegmentLoading, isLoading } =
    useEditSegmentView();

  const { fields, append, remove } = useFieldArray({
    name: "conditions.1.conditions",
  });

  const { trigger } = useFormContext();

  const addConditionGroup = () => {
    append({
      type: "combined",
      conditionType: "AND",
      conditions: [
        {
          type: "base",
          attributeType: "",
          attributeName: "",
          criteria: "",
          value: {},
        },
      ],
    });
    trigger();
  };

  const deleteGroup = (index: number) => {
    remove(index);
  };

  return {
    mdUp,
    addConditionGroup,
    fields,
    deleteGroup,
    editDisabled,
    editDisabledTooltip,
    isLoading,
    isSegmentLoading,
  };
}
